import { DatePipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import {
  PersonSimpleWithRole,
  ProjectPublicResponse,
} from '@app/models/project.models';
import { CurrencyFormatPipe } from '@app/pipes/currency-format.pipe';
import { BaseEnumItemByIdPipe } from '@app/pipes/base-enum-item-by-id.pipe';
import { GetLocalizedPipe } from '@app/pipes/get-localized.pipe';
import { GenericStore } from '@app/stores/generic.store';
import { GenericProjectStore } from '@app/stores/projects/generic-project.store';
import { CardComponent } from '@app/ui-components/card/card.component';
import { InfoLabelComponent } from '@app/ui-components/info-label/info-label.component';
import { LabeledContentComponent } from '@app/ui-components/labeled-content/labeled-content.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NamePositionEmailDisplayComponent } from '../name-position-email-display/name-position-email-display.component';
import { NamePositionEmailData } from '../name-position-email-display/name-position-email-display.models';
import { NotOwnedDevicesDisplayComponent } from '../not-owned-devices-display/not-owned-devices-display.component';

@Component({
  selector: 'app-project-details-section-d',
  imports: [
    DatePipe,
    TranslatePipe,
    CurrencyFormatPipe,
    BaseEnumItemByIdPipe,
    CardComponent,
    LabeledContentComponent,
    InfoLabelComponent,
    NamePositionEmailDisplayComponent,
    NotOwnedDevicesDisplayComponent,
  ],
  templateUrl: './project-details-section-d.component.html',
  styleUrl: './project-details-section-d.component.scss',
  providers: [GetLocalizedPipe],
})
export class ProjectDetailsSectionDComponent {
  projectDetails = input.required<ProjectPublicResponse>();
  genericProjectStore = inject(GenericProjectStore);
  private genericStore = inject(GenericStore);
  protected translationKey = 'projectDetails.sectionD.';

  constructor(private localizedPipe: GetLocalizedPipe) {}

  private titlePrefix(person: PersonSimpleWithRole): string {
    if (person.titleCode === null) return '';
    const entity = this.genericStore
      .nameTitlesEntities()
      .find(
        (t) => t.code === person.titleCode || t.id === person.titleCode,
      );
    if (entity !== undefined) {
      return (this.localizedPipe.transform(entity.localized) || '').trim();
    }
    return person.titleCode;
  }

  protected getPersonData(person: PersonSimpleWithRole): NamePositionEmailData {
    let name = '';
    const prefix = this.titlePrefix(person);
    if (prefix !== '') {
      name = prefix + ' ';
    }
    name += person.firstName;
    if (person.midName !== null) {
      name += ' ' + person.midName;
    }
    name += ' ' + person.lastName;

    return {
      name,
      position: person.position === null ? '-' : person.position,
      email: person.email,
    };
  }
}
